import useUrlState from '@ahooksjs/use-url-state';
import { useLocalStorageState } from 'ahooks';
import { Tabs } from 'antd';
import moment from 'moment';
import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ReportGuideType, RouteWithProUpgrade } from '@/config/app/auth';
import i18n from '@/i18n';
import { getParamFromUrl, replaceHistory, toSearchObj } from '@/infrastructure/history';
import { PAGE_ID } from '@/infrastructure/reporter/datong/id';
import { ReportField, ReportScene, useReportPage } from '@/infrastructure/reporter/datong/report';
import { getIssueDefault } from '@/infrastructure/utils/issue';
import { FilterEntry } from '@/presentation/components/form/types';
import { Issues } from '@/presentation/components/issue';
import { NetTrendAnalysis } from '@/presentation/components/issue-trend-analysis/net-trend-analysis';
import { TIME_RANGE } from '@/presentation/config/storage';
import { TimeRangeStorageType } from '@/presentation/config/type';
import { NetExceptionListContext } from '@/presentation/pages/traffic/issues/list/context';
import { NetProblemForm } from '@/presentation/pages/traffic/issues/list/form';
import { ProblemList } from '@/presentation/pages/traffic/issues/list/table';
import { IssueTimeType, IssueType } from '@/proto/issue';
import { MetricType, TimeType } from '@/proto/metric';
import styles from './index.module.scss';
import { FlowAnalysis } from './table/flow';
export enum SubType {
  issueAnalytics = 'issue_analytics',
  trafficProblem = 'traffic_problem',
}

export default function () {
  const history = useHistory();
  const { pathname } = useLocation();
  useReportPage(PAGE_ID.net.list);
  const [token, setToken] = useState(getParamFromUrl(''));
  const [timeRangeState, setTimeRangeState] = useLocalStorageState<TimeRangeStorageType>(TIME_RANGE, {});
  const [urlTab, setUrlTab] = useUrlState({ tab: SubType.issueAnalytics });

  const onFinish = (value: Record<string, any>, issuesFinish: (value: Record<string, any>) => void) => {
    issuesFinish?.(value);
    // 缓存时间
    if (value.timeQuick) {
      setTimeRangeState(state => ({ ...state,
        [PAGE_ID.net.list]: { timeQuick: value.timeQuick, timeWindow: value.timeWindow } }));
    }
  };

  const tabOnChange = (urlTab: any) => {
    setUrlTab({ tab: urlTab });
    const currentSearch = toSearchObj(window.location.search);
    const searchObj = {
      ...currentSearch,
      token: '',
    };
    replaceHistory(history, pathname, searchObj);
  };


  return (
    <RouteWithProUpgrade
    reportGuideType={ReportGuideType.GuidePage}
    reportScene={ReportScene.TrafficList}
    reportField={ReportField.TrafficList}>
    <NetExceptionListContext.Provider value={{
      token,
      setToken,
      pageId: PAGE_ID.net.list,
      issueType: IssueType.ISSUE_TYPE_TRAFFIC,
    }}>
      <Tabs className={styles.tabs} onChange={tabOnChange} activeKey={urlTab.tab}>
        <Tabs.TabPane tab={i18n.t('个例分析')} key={ SubType.issueAnalytics} >
          <Issues
            defaultFields={timeRangeState?.[PAGE_ID.net.list] ? getIssueDefault(timeRangeState?.[PAGE_ID.net.list]) : {
              timeWindow: TimeType.MINUTE5,
              timeQuick: 'custom',
              startTime: moment().startOf('day')
                .unix(),
              endTime: moment().endOf('day')
                .unix(),
            }}
            pgId={PAGE_ID.net.list}
            renderForm={props => (
              <NetProblemForm
                tokenInitValues={props.tokenInitValues}
                initialValue={props.initialValue}
                onFinish={value => onFinish(value, props.onFinish)}
                entry={FilterEntry.NetList}
                subType={SubType.issueAnalytics}
              />
            )}
            renderTrendAnalysis={props => (
              <NetTrendAnalysis
                issueType={IssueType.ISSUE_TYPE_TRAFFIC}
                metricType={MetricType.TYPE_TRAFFIC_RESOURCE}
                token={props.token}
                timeWindow={
                  props.fields?.timeWindow ?? IssueTimeType.TIME_TYPE_MINUTE5
                }
                headToken={props.token}
                pgId={PAGE_ID.net.list}
              />
            )}
            renderList={props => (
              <ProblemList
                token={props.token}
                simpleToken={props.token}
                fields={props.fields}
                fetch={props.fetch}
              />
            )}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab={i18n.t('流量归因')} key={ SubType.trafficProblem}>
          <Issues
            defaultFields={{
              startTime: moment().startOf('day')
                .unix(),
              endTime: moment().endOf('day')
                .unix(),
            }}
            pgId={PAGE_ID.net.list}
            renderForm={props => (
              <NetProblemForm
                tokenInitValues={props.tokenInitValues}
                initialValue={props.initialValue}
                onFinish={value => onFinish(value, props.onFinish)}
                entry={FilterEntry.NetList}
                subType={SubType.trafficProblem}
              />
            )}
            renderList={props => <FlowAnalysis token={props.token} />}
          />
        </Tabs.TabPane>
      </Tabs>
    </NetExceptionListContext.Provider>
    </RouteWithProUpgrade>
  );
}

